import { ITextProps, Text } from "components/common/form/modules/input/Text";
import React from "react";

export const TextArea = (props: ITextProps) => {
  return <Text {...props} textarea={true} />;
};



// WEBPACK FOOTER //
// ./src/components/common/form/modules/input/TextArea.tsx